export default "__VITE_ASSET__zKRY$KWd__"